// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AllocationsController from "./allocations_controller"
application.register("allocations", AllocationsController)

import ArticlesController from "./articles_controller"
application.register("articles", ArticlesController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BudgetCompleteController from "./budget_complete_controller"
application.register("budget-complete", BudgetCompleteController)

import BudgetController from "./budget_controller"
application.register("budget", BudgetController)

import BudgetCreateController from "./budget_create_controller"
application.register("budget-create", BudgetCreateController)

import BudgetDetailsController from "./budget_details_controller"
application.register("budget-details", BudgetDetailsController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import CommunicationsController from "./communications_controller"
application.register("communications", CommunicationsController)

import ContactsTablesController from "./contacts_tables_controller"
application.register("contacts-tables", ContactsTablesController)

import ContextController from "./context_controller"
application.register("context", ContextController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import InvestmentsController from "./investments_controller"
application.register("investments", InvestmentsController)

import LpOnboardingController from "./lp_onboarding_controller"
application.register("lp-onboarding", LpOnboardingController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import NetSnapshotController from "./net_snapshot_controller"
application.register("net-snapshot", NetSnapshotController)

import NewInvestmentsController from "./new_investments_controller"
application.register("new-investments", NewInvestmentsController)

import OnboardingAttachmentsController from "./onboarding_attachments_controller"
application.register("onboarding-attachments", OnboardingAttachmentsController)

import OnboardingEntityController from "./onboarding_entity_controller"
application.register("onboarding-entity", OnboardingEntityController)

import OnboardingGeneralController from "./onboarding_general_controller"
application.register("onboarding-general", OnboardingGeneralController)

import OnboardingOnboardingController from "./onboarding_onboarding_controller"
application.register("onboarding-onboarding", OnboardingOnboardingController)

import OnboardingSignatoriesController from "./onboarding_signatories_controller"
application.register("onboarding-signatories", OnboardingSignatoriesController)

import OwnerController from "./owner_controller"
application.register("owner", OwnerController)

import PasswordController from "./password_controller"
application.register("password", PasswordController)

import QuarterAssignmentController from "./quarter_assignment_controller"
application.register("quarter-assignment", QuarterAssignmentController)

import ReportingController from "./reporting_controller"
application.register("reporting", ReportingController)

import ReviseInvestmentController from "./revise_investment_controller"
application.register("revise-investment", ReviseInvestmentController)

import SecuritiesController from "./securities_controller"
application.register("securities", SecuritiesController)

import SecurityController from "./security_controller"
application.register("security", SecurityController)

import SignatoryController from "./signatory_controller"
application.register("signatory", SignatoryController)

import SnapshotPortcoReviewController from "./snapshot_portco_review_controller"
application.register("snapshot-portco-review", SnapshotPortcoReviewController)

import SnapshotRerunParserController from "./snapshot_rerun_parser_controller"
application.register("snapshot-rerun-parser", SnapshotRerunParserController)

import SnapshotStatementsReviewController from "./snapshot_statements_review_controller"
application.register(
  "snapshot-statements-review",
  SnapshotStatementsReviewController,
)

import SnapshotsController from "./snapshots_controller"
application.register("snapshots", SnapshotsController)

import StatusController from "./status_controller"
application.register("status", StatusController)

import StickyTableController from "./sticky_table_controller"
application.register("sticky-table", StickyTableController)

import SummaryController from "./summary_controller"
application.register("summary", SummaryController)

import UploadSecuritiesController from "./upload_securities_controller"
application.register("upload-securities", UploadSecuritiesController)
